import React from 'react'
import CommonOrder from '../commonorder/CommonOrder'

const HiloOrder = () => {
  return (
    <>
      <CommonOrder/>
      <CommonOrder/>
      <CommonOrder/>
      
    </>
  )
}

export default HiloOrder